import { useCallback, useMemo } from 'react';
import { useLocalStorageByUser } from 'common/hooks';
import {
  createEmptySuperSearchHistory,
  getSuperSearchHistoryDestination,
  normalizeSuperSearchHistory,
  recordSuperSearchDestination,
  SUPER_SEARCH_HISTORY_VERSION,
} from './SuperSearch.history';
import type { SuperSearchDisplayItem } from './SuperSearch.types';

const apiEnvironment = [process.env.REACT_APP_ENVIRONMENT, process.env.REACT_APP_API_ENDPOINT]
  .filter(Boolean)
  .join(':');
const SUPER_SEARCH_HISTORY_KEY = `superSearchHistory:v${SUPER_SEARCH_HISTORY_VERSION}:${encodeURIComponent(apiEnvironment || 'default')}`;

const useSuperSearchHistory = () => {
  const [storedHistory, setStoredHistory, isReady] = useLocalStorageByUser<unknown>(
    SUPER_SEARCH_HISTORY_KEY,
    createEmptySuperSearchHistory()
  );
  const history = useMemo(() => normalizeSuperSearchHistory(storedHistory), [storedHistory]);

  const recordItem = useCallback(
    (item: SuperSearchDisplayItem) => {
      const destination = getSuperSearchHistoryDestination(item);
      if (!destination) {
        return;
      }

      setStoredHistory((previousHistory: unknown) => recordSuperSearchDestination(previousHistory, destination));
    },
    [setStoredHistory]
  );

  const clearHistory = useCallback(() => {
    setStoredHistory(createEmptySuperSearchHistory());
  }, [setStoredHistory]);

  return {
    clearHistory,
    history,
    isReady,
    recordItem,
  };
};

export default useSuperSearchHistory;
